"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mainLogger = exports.logDebug = void 0;
var _checkoutUtils = require("@ori/checkout-utils");
var _logger = require("@ori/logger");
var _constantsGenerated = require("./constants-generated");
const mainLogger = exports.mainLogger = new _logger.Logger(_constantsGenerated.PACKAGE_NAME, {
  teamName: _constantsGenerated.TEAM_NAME
});
const logDebug = exports.logDebug = (0, _checkoutUtils.getDebugLogger)(_constantsGenerated.APP_NAME);
